import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import PagesForm from '../../../components/forms/PagesForm';
import { usePagesApi } from '../../../hooks/usePagesApi';
import { useNavigate } from 'react-router-dom';
import { PagesDTO } from '../../../services/apiClient';

const PagesCreate: React.FC = () => {
  const { create } = usePagesApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Pages', href: '/admin/pages' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: PagesDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/pages');
    } catch (error) {
      console.error('Error creating Page:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/pages"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Content.Page.Edit"
    >
      <PagesForm
        initialValues={{ isActive: true, isVisible: true } as PagesDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/pages')}
        isLoading={isSubmitting}
      />
    </AdminLayout>
  );
};

export default PagesCreate;
